module.exports = __webpack_public_path__ + "static/img/mf_slider4.b6bfd91.webp";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/mf_slider4.webp
// module id = 8Q/F
// module chunks = 5